import React from 'react';

import './index.scss';

const BubbleNote = ({ message }) => {
  return (
    <div className="note">
      <div className="note__bubble">
        <p>{message}</p>
        <div className="note-visibility">Visible only to your team</div>
      </div>
    </div>
  );
};

export default BubbleNote;
